module.exports = "https://cdn.hellotech.com/client-assets/advanced_audio_systems_tablet_f5e0a83e802797457e86f3dcd576a621.webp";